import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { CreateAssetTypeViewTopBar } from "./TopBar"

export const createAssetTypeViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: CreateAssetTypeViewTopBar,
}
